import { Button, Label, Spinner } from "@enpowered/ui";
import PropTypes from "prop-types";
import React from "react";

const DeleteBillModal = ({ onConfirm, onCancel, isDeleting }) => {
  // Not sure how we plan to get the file or how much of it we plan to render etc...
  // For now just leaving it as a white box
  return (
    <div>
      <Label className="mb-8">
        Are you sure you wish to delete the selected upload(s)? You can not
        retrieve this data again once it is deleted.
      </Label>
      <div className="flex justify-end mt-2">
        <Button
          size="narrow"
          theme="none"
          className="mr-4 bg-white border border-en-gray-300"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          size="narrow"
          theme="none"
          className="bg-en-red text-white"
          onClick={onConfirm}
        >
          {isDeleting ? <Spinner /> : "Delete Bill"}
        </Button>
      </div>
    </div>
  );
};

DeleteBillModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool
};

export default DeleteBillModal;
